import { render, staticRenderFns } from "./UploadDocumentTableMixin.vue?vue&type=template&id=62b1b47f&"
import script from "./UploadDocumentTableMixin.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentTableMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports